import React from 'react';
import CertificateField from './CertificateField';
import styles from './styles.module.scss';
// import { certificates } from './data.js';

function Certificates() {
	return (
		<div
			className={`box moreBox ${styles.certificatesContainer}`}
			id='certificatesBox'
		>
			<h1 className='section-title'>Courses & Certificates</h1>

			<div className={styles.certificateFields}>
				<CertificateField type='Web Development' />
				<CertificateField type='Mobile Development' />
				<CertificateField type='Algorithms' />
				<CertificateField type='Security' />
				<CertificateField type='Programming' />
				<CertificateField type='Others' />
			</div>
		</div>
	);
}

export default Certificates;
